export default __webpack_public_path__ + "static/media/home-cafe-img-04.b58bd03b.jpg";